export const LAW = {
  SHOUGAI: "障害者自立支援法",
  JIDOU: "児童福祉法",
  KAIGO: "介護保険法",
};

export const TITLE = "地域区分を調べる";

export const INITIAL_RESULT_MESSAGE =
  "「地域区分を調べる」を押すとこちらに検索結果が表示されます。";

export const DEFAULT_FORM = {
  law: "",
  date: "2024-04-01",
  keikasochi: false,
  addr: "",
};

export const INITIAL_VIEW_STATE = {
  status: "initial",
  message: INITIAL_RESULT_MESSAGE,
};

export const SEARCH_MESSAGES = {
  csvNotReady: "CSVデータの読み込みが完了していません。",
  addrRequired: "住所を入力してください。",
};

export const LAW_OPTIONS = [
  { value: "", label: "(ここから選ぶ)" },
  { value: LAW.JIDOU, label: "児童福祉法" },
  { value: LAW.SHOUGAI, label: "障害者総合支援法" },
  { value: LAW.KAIGO, label: "介護保険法" },
];

export const KEIKA_OPTIONS = [
  { value: false, label: "なし" },
  { value: true, label: "あり" },
];

export const YEAR_OPTIONS = [
  { value: "2011-04-01", label: "平成２３年度以前" },
  { value: "2012-04-01", label: "平成２４年度" },
  { value: "2013-04-01", label: "平成２５年度" },
  { value: "2014-04-01", label: "平成２６年度" },
  { value: "2015-04-01", label: "平成２７年度" },
  { value: "2016-04-01", label: "平成２８年度" },
  { value: "2016-04-01", label: "平成２９年度" },
  { value: "2018-04-01", label: "平成３０年度" },
  { value: "2019-04-01", label: "平成３１年度" },
  { value: "2020-04-01", label: "令和２年度" },
  { value: "2021-04-01", label: "令和３年度" },
  { value: "2024-04-01", label: "令和６年度" },
];

export const JIDOU_SERVICES = [
  "児童発達支援",
  "医療型児童発達支援",
  "放課後等デイサービス",
  "保育所等訪問支援",
  "居宅訪問型児童発達支援",
  "福祉型障害児入所施設",
  "医療型障害児入所施設",
  "障害児相談支援",
];

export const SHOUGAI_SERVICES = [
  "居宅介護",
  "重度訪問介護",
  "行動援護",
  "重度障害者等包括支援",
  "同行援護",
  "療養介護、経過的療養介護",
  "生活介護、経過的生活介護",
  "短期入所",
  "施設入所支援、経過的施設入所支援",
  "共同生活援助",
  "宿泊型自立訓練",
  "自立生活援助",
  "自立訓練（機能訓練）",
  "自立訓練（生活訓練）",
  "就労移行支援",
  "就労移行支援（養成施設）",
  "就労継続支援Ａ型",
  "就労継続支援Ｂ型",
  "就労定着支援",
  "就労選択支援",
  "地域移行支援",
  "地域定着支援",
  "計画相談支援",
];
